import { createContext, useContext, useState, useEffect } from 'react';
import { supabase } from '../supabase';

const AuthContext = createContext({});

export function AuthProvider({ children }) {
  const [sessao, setSessao] = useState(null);
  const [usuario, setUsuario] = useState(null);
  const [carregando, setCarregando] = useState(true);

  useEffect(() => {
    supabase.auth.getSession().then(({ data: { session } }) => {
      setSessao(session);
      if (session) carregarUsuario(session.user.id);
      else setCarregando(false);
    });

    const { data: { subscription } } = supabase.auth.onAuthStateChange((_event, session) => {
      setSessao(session);
      if (session) carregarUsuario(session.user.id);
      else {
        setUsuario(null);
        setCarregando(false);
      }
    });

    return () => subscription.unsubscribe();
  }, []);

  const carregarUsuario = async (userId) => {
    const { data } = await supabase
      .from('usuarios')
      .select('*')
      .eq('id', userId)
      .single();
    setUsuario(data);
    setCarregando(false);
  };

  const logout = async () => {
    await supabase.auth.signOut();
  };

    const isAdmin = usuario?.role === 'admin';
    const isManager = usuario?.role === 'admin';
    const podeVerAds = usuario?.role === 'admin' || (usuario?.role === 'membro' && usuario?.modulo_ads);
    const podeVerSocial = usuario?.role === 'admin' || (usuario?.role === 'membro' && usuario?.modulo_social);
    const podeVerFinanceiro = usuario?.role === 'admin';

  return (
    <AuthContext.Provider value={{
      sessao,
      usuario,
      carregando,
      logout,
      isAdmin,
      isManager,
      podeVerAds,
      podeVerSocial,
      podeVerFinanceiro
    }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);